import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import DOMPurify from 'dompurify';
import { format } from "date-fns";
import { hi } from "date-fns/locale";
import { Circles } from 'react-loader-spinner';
import { faFacebook, faXTwitter, faWhatsapp, faInstagram } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock } from "@fortawesome/free-solid-svg-icons";
// import './style1.css';

const truncateText = (text, maxLength) => {
  if (text.length > maxLength) {
    return text.substring(0, maxLength) + "...";
  }
  return text;
};
const renderHtmlContent = (html) => {
  const sanitizedHtml = DOMPurify.sanitize(html);
  return { __html: sanitizedHtml };
};
const stripHtmlTags = (html, maxLength) => {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;
  const strippedText = tempDiv.textContent || tempDiv.innerText || "";
  return truncateText(strippedText, maxLength);
};
const formatDateInHindi = (dateString) => {
  const date = new Date(dateString);
  return format(date, "do MMMM yyyy", { locale: hi });
};

const local = "https://localhost:44351/api/home/tajaKhabars"
const online = "https://api.shabdtoday.com/api/home/tajaKhabars"
const clicklocal = "https://localhost:44351/api/home/update-viewcount"
const clickonline = "https://api.shabdtoday.com/api/home/update-viewcount"


export default function Footer() {
  const [posts, setPosts] = useState([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${online}?page=${page}&limit=5`);
        setPosts(response.data);
        setLoading(false);
      } catch (error) {
        setError(error.message);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const formatDateInHindi = (dateString) => {
    const date = new Date(dateString);
    const monthsInHindi = [
      "जनवरी",
      "फरवरी",
      "मार्च",
      "अप्रैल",
      "मई",
      "जून",
      "जुलाई",
      "अगस्त",
      "सितंबर",
      "अक्टूबर",
      "नवंबर",
      "दिसंबर",
    ];
    const seconds = date.getSeconds();
    const minute = date.getMinutes();
    var hour = date.getHours();
    const day = date.getDate();
    const month = monthsInHindi[date.getMonth()];
    const year = date.getFullYear();
    const amPm = hour >= 12 ? "PM" : "AM";
    hour = hour % 12 || 12;
    return `${day} ${month} ${year} \n ${hour}:${minute < 10 ? "0" + minute : minute} ${amPm}`;
  };
  const generateShareLinks = (mainKhabarId, newsTag) => {
    const encodednewsTag = encodeURIComponent(newsTag);
    const url = `${window.location.origin}/News-Details/${mainKhabarId}`;
    return {
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${url}&quote=${encodednewsTag}`,
      whatsapp: `https://api.whatsapp.com/send?text=${encodednewsTag} ${url}`
    };
  };

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Circles
          height="30"
          width="30"
          color="#f7265c"
          ariaLabel="circles-loading"
          wrapperStyle={{}}
          wrapperClass=""
          visible={true}
        />
      </div>
    );
  }

  const handleNewsClick2 = async (slug, mainKhabarId) => {
    try {
      const response = await axios.post(clickonline, { mainKhabarId: mainKhabarId });

      if (response.status === 200) {
        // console.log("View count updated successfully", response.data);
        window.location.href = `/News-Details/${slug}`;
      } else {
        console.error("Failed to update view count:", response.data);
      }
    } catch (error) {
      if (error.response) {
        console.error("Server error:", error.response.status, error.response.data);
      } else if (error.request) {
        console.error("No response from server:", error.request);
      } else {
        console.error("Error:", error.message);
      }
    }
  };

  if (error) {
    return <div>Error: {error}</div>;
  }

  // Define base URL for images
  const baseUrl = "https://api.shabdtoday.com/";
  const image_resize = "https://api.shabdtoday.com/api/home/resize";

  return (
    <div>
      <div className="ak-footer-wrap">
        <div className="ak-container">
          <div className="ak-bar ak-footer-bar ak-top-bar ak-bar-dark dark full-width clearfix">
            <div className="container">
              <div className="ak-bar-inner">
                <div className="ak-row ak-row-items-middle ak-row-responsive">
                  <div className="ak-column ak-column-center ak-column-normal">
                    <div className="ak-inner-row ak-row-items-middle ak-justify-content-left">
                      <div className="ak-footer-widgets">
                        <div className="row" style={{ display: "block" }}>
                          <div className="col-sm-4 ak-footer-column">
                            <aside className="sidebar sidebar-footer-1">
                              <div id="newsy_about_us-3" className="widget widget_newsy_about_us" >
                                <div className="ak-block ak-block-about-us  ak-block-width-1 clearfix" id="block_65f7f61f36732_27"  >
                                  <div className="ak-block-header ak-block-header-style-5 no-tabs">
                                    <h2 className="ak-block-title">  <span className="title-text"> <span>हमारे बारे में</span> </span> </h2> </div>
                                  <div className="ak-block-inner clearfix">
                                    <div className="ak-about-image">
                                      <Link to="/">
                                        <img
                                          loading="lazy"
                                          src="/design/images/logo-Anils.webp"
                                          alt="NewsImage"
                                          width={333}
                                          height={140}
                                          style={{
                                            height: "120px",
                                            width: "1120px",
                                          }}
                                        />
                                      </Link>
                                    </div>
                                  <p className="ak-about-description text-white">
                                    शब्द टुडे मध्य प्रदेश का एक प्रमुख हिंदी न्यूज समाचारपत्र है। मध्य प्रदेश में इसके 2 संस्‍करण प्रकाशित हो रहे हैं। एक संस्करण मध्य प्रदेश और दूसरा बैतूल से प्रकाशित हो रहा है। शब्द टुडे मध्य प्रदेश के सबसे अधिक पढ़े जाने वाले समाचार पत्रों में से एक है।
                                    <Link to="/" className="ak-about-link" aria-label="शब्द टुडे " />  </p>
                                  <div className="ak-about-social-items">
                                    <ul className="ak-social-counter social-counter-style-4 social-counter-light-box clearfix">
                                      <li className="social-item">
                                        <Link to="https://www.facebook.com/shabdtoday" aria-label="Facebook" className=" facebook" target="_blank" rel="external noopener nofollow" >  <FontAwesomeIcon icon={faFacebook} style={{ color: "#1877F2", fontSize: "24px" }} /><span className="item-count">  0 </span><span className="item-name"> Facebook </span>  <span className="item-title">   Likes  </span>  <span className="item-join"> Join us on Facebook </span> <span className="item-button"> Like our page  </span>  </Link>
                                      </li>  
                                      {/* <li className="social-item">

                                        <Link to="https://www.twitter.com" aria-label="Twitter" className=" twitter" target="_blank" rel="external noopener nofollow"  > <FontAwesomeIcon icon={faXTwitter} style={{ color: "#1DA1F2", fontSize: "24px" }} /><span className="item-count">  0</span>  <span className="item-name"> Twitter </span> <span className="item-title">  Followers  </span><span className="item-join">  Join us on Twitter </span> <span className="item-button">  Follow Us </span>
                                        </Link>  </li>   */}
                                        <li className="social-item">

                                        <Link to="https://www.instagram.com/shabdtodaylive/" aria-label="Instagram" className=" instagram" target="_blank" rel="external noopener nofollow" >
                                          <FontAwesomeIcon icon={faInstagram} style={{ color: "#E4405F", fontSize: "24px" }} /> <span className="item-count">   0 </span> <span className="item-name"> Instagram </span>
                                          <span className="item-title">  Followers   </span>   <span className="item-join">   Join us on Instagram  </span>   <span className="item-button">  Follow Us  </span> </Link>     </li>
                                      <li className="social-item">

                                        <Link to="https://whatsapp.com" aria-label="Instagram" className=" whatsapp" target="_blank" rel="external noopener nofollow" >
                                          <FontAwesomeIcon icon={faWhatsapp} style={{ color: "#25D366", fontSize: "24px" }} /> <span className="item-count">   0 </span> <span className="item-name"> whatsapp </span>
                                          <span className="item-title">  Followers   </span>   <span className="item-join">   Join us on whatsapp  </span>   <span className="item-button">  Follow Us  </span> </Link>     </li>
                                      <li className="social-item">

                                      </li> </ul> </div> </div> </div>  </div> </aside>  </div>
                      <div className="col-sm-4 ak-footer-column">
                        <aside className="sidebar sidebar-footer-2">
                          <div
                            id="newsy_list_1_small_square-3"
                            className="widget widget_newsy_list_1_small_square"
                          >
                            <div
                              className="ak-block ak-block-list-1-small-square ak-block-column ak-block-module-thumb-round ak-block-width-1 clearfix"
                              id="block_65f7f61f36732_28"
                            >
                              <div className="ak-block-header ak-block-header-style-5 no-tabs">
                                <h2 className="ak-block-title">
                                  <span className="title-text">
                                    <span>ट्रेंडिंग पोस्ट्स</span>
                                  </span>
                                </h2>
                              </div>

                              <div className="ak-block-inner clearfix">
                                <div className="ak-block-posts clearfix">
                                  {posts.tazaKhabars.slice(0, 3).map((post) => {
                                    const shareLinks = generateShareLinks(
                                      post.mainKhabarId,
                                      post.newsTag
                                    );

                                    const openNews = (e) => {
                                      e.preventDefault();
                                      handleNewsClick2(post.slug, post.mainKhabarId);
                                    };

                                    return (
                                      <article
                                        key={post.mainKhabarId}
                                        className="bordergap mt-2 ak-module ak-module-1-small-square ak-column-module clearfix ak-exclusive-post"
                                      >
                                        <div className="ak-module-inner clearfix">
                                          {/* Image Section */}
                                          <div className="ak-module-featured">
                                            <div className="ak-module-badges" />
                                            <div className="ak-module-video-duration" />
                                            <div className="ak-featured-cover">
                                              <Link
                                                to="#"
                                                onClick={openNews}
                                                className="ak-featured-link"
                                                rel="bookmark"
                                                title={post.title}
                                              >
                                                <img
                                                  src={`${baseUrl}${post.newsImage}`}
                                                  alt={post.newsTag}
                                                  style={{
                                                    height: "80px",
                                                    width: "70px",
                                                    objectFit: "cover",
                                                  }}
                                                />
                                              </Link>
                                            </div>
                                          </div>

                                          {/* Details Section */}
                                          <div className="ak-module-details">
                                            {/* Clickable News Tag */}
                                            {post.newsTag && (
                                              <div
                                                className="ak-module-tag"
                                                style={{
                                                  color: "white",
                                                  fontWeight: "bold",
                                                  fontSize: "13px",
                                                  marginBottom: "3px",
                                                }}
                                              >
                                                <Link
                                                  to="#"
                                                  onClick={openNews}
                                                  style={{
                                                    color: "white",
                                                    fontSize: "16px",
                                                    textDecoration: "none",
                                                  }}
                                                  dangerouslySetInnerHTML={renderHtmlContent(
                                                    post.newsTag
                                                  )}
                                                />
                                              </div>
                                            )}

                                            {/* Meta Info (Time) */}
                                            <div className="ak-module-meta">
                                              <div className="ak-module-time">
                                                <Link
                                                  to="#"
                                                  onClick={openNews}
                                                  className="ak-module-meta-published"
                                                  style={{ fontSize: "14px", marginTop: "3px" }}
                                                >
                                                  {/* <FontAwesomeIcon
                                                        icon={faClock}
                                                        style={{ color: "grey", fontSize: "12px" }}
                                                      /> */}
                                                </Link>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </article>
                                    );
                                  })}
                                </div>
                              </div>
                            </div>
                          </div>
                        </aside>
                      </div>

                      <div className="col-sm-4 ak-footer-column"> <aside className="sidebar sidebar-footer-3"><div
                        id="newsy_popular_categories-3" className="widget widget_newsy_popular_categories" > <div
                          className="ak-block ak-block-categories  ak-block-width-2 clearfix"
                          id="block_65f7f61f36732_29" ><div className="ak-block-header ak-block-header-style-5 no-tabs">
                            <span className="ak-block-title"> <span className="title-text"><span>पॉपुलर कैटेगरी</span> </span> </span> </div> <div className="ak-block-inner clearfix">  <ul className="popular-cats-list  columns-2">
                              <li className="popular-cat-item term-49">
                                <Link className="link" to="/TajaKhabar-News" >ताजा खबरें <span className="term-count">1</span> </Link> </li>
                              <li className="popular-cat-item term-47">  <Link className="link" to="/MadhyaPradesh-News" > मध्य प्रदेश
                                <span className="term-count">2</span> </Link>  </li> <li className="popular-cat-item term-43">
                                <Link className="link" to="/Chhattisgarh-News"> छत्तीसगढ़ <span className="term-count">3</span> </Link> </li> <li className="popular-cat-item term-46"> <Link className="link" to="/Webstorie-News" >  वेब स्टोरीज <span className="term-count">4</span>  </Link> </li>
                              <li className="popular-cat-item term-48"> <Link className="link" to="/MadhyaPradesh-News" > देश  <span className="term-count">5</span>
                              </Link>  </li>  <li className="popular-cat-item term-50"> <Link className="link" to="/Khel-News" >  क्रिकेट<span className="term-count">6</span>
                              </Link> </li> </ul> </div>  </div> </div> <div id="tag_cloud-3" className="widget widget_tag_cloud" >
                          <div className="ak-block-header ak-block-header-style-5"> <h2 className="widget-title ak-block-title"><span className="title-text">टैग्स </span> </h2> </div> <div className="tagcloud mt-2"> <Link to="/Buisness-News" className="tag-cloud-link tag-link-54 tag-link-position-1"
                            style={{ fontSize: "8pt" }} aria-label="Breaking (30 items)" > बिज़नेस </Link> <Link to="/Bollywood-News"
                              className="tag-cloud-link tag-link-55 tag-link-position-2" style={{ fontSize: "8pt" }}
                              aria-label="Election (30 items)" >  बॉलीवुड </Link> <Link to="/Chhattisgarh-News" className="tag-cloud-link tag-link-52 tag-link-position-3"
                                style={{ fontSize: "8pt" }} aria-label="Politics (30 items)" > छत्तीसगढ़ </Link> <Link to="/Rashifal-News" className="tag-cloud-link tag-link-53 tag-link-position-4" style={{ fontSize: "8pt" }}
                                  aria-label="Technology (30 items)"  >राशिफल </Link> <Link to="/Video-News" className="tag-cloud-link tag-link-56 tag-link-position-5"
                                    style={{ fontSize: "8pt" }} aria-label="World News (30 items)">  वीडियो </Link>
                          </div><div className="tagcloud">  <Link to="/International-News" className="tag-cloud-link tag-link-55 tag-link-position-2" style={{ fontSize: "8pt" }} aria-label="Election (30 items)" > अन्तर्राष्ट्रीय </Link>  <Link to="/Khel-News" className="tag-cloud-link tag-link-52 tag-link-position-3" style={{ fontSize: "8pt" }} aria-label="Politics (30 items)" >  खेल </Link> <Link to="/Daram-News"
                            className="tag-cloud-link tag-link-53 tag-link-position-4" style={{ fontSize: "8pt" }} aria-label="Technology (30 items)"
                          >  धर्म  </Link> <Link to="/MadhyaPradesh-News" className="tag-cloud-link tag-link-53 tag-link-position-4" style={{ fontSize: "8pt" }} aria-label="Technology (30 items)" > मध्य प्रदेश  </Link> <Link to="/Webstorie-News" className="tag-cloud-link tag-link-56 tag-link-position-5" style={{ fontSize: "8pt" }} aria-label="World News (30 items)" > वेब स्टोरीज </Link> </div> </div> </aside> </div>
                    </div>  </div> </div> </div></div> </div> </div> </div>
      <div className="ak-bar ak-footer-bar ak-mid-bar ak-bar-dark dark full-width clearfix">
        <div className="container"> <div className="ak-bar-inner">
          <div className="ak-row ak-row-items-middle ak-row-responsive"> <div className="ak-column ak-column-left ak-column-grow">
            <div className="ak-inner-row ak-row-items-middle ak-justify-content-left">  <div className="ak-bar-item ak-footer-copyright">
              Copyright © {new Date().getFullYear()}
              <Link to="https://shabdtoday.com/" title="Just another Newsy Demo site"  >शब्द टुडे  </Link>
              <Link to="https://shabdtoday.com/" title="शब्द टुडे " />
            </div>
            </div>
          </div>
            <div className="ak-column ak-column-right ak-column-grow">
              <div className="ak-inner-row ak-row-items-middle ak-justify-content-right">
                <div className="ak-bar-item ak-footer-menu-container ">
                  <ul id="menu-footer-navigation" className="ak-menu ak-menu-wide ak-menu-style-6 ak-footer-menu">
                    <li id="menu-item-273" className="menu-item menu-item-type-custom menu-item-object-custom menu-item-273"  >
                      <Link to="/PrivacyPolicy">
                        {/* <span> Advertise with Us</span> */}
                        <span> Privacy Policy</span>
                      </Link>
                    </li>
                    <li id="menu-item-273" className="menu-item menu-item-type-custom menu-item-object-custom menu-item-273"  >
                      <Link to="/ContactUs">
                        {/* <span> Advertise with Us</span> */}
                        <span> Contact Us</span>
                      </Link>
                    </li>
                    <li
                      id="menu-item-275" className="menu-item menu-item-type-custom menu-item-object-custom menu-item-275">
                      <Link to="https://shabdtoday.com/">
                        <span>www.shabadtoday.com</span>
                      </Link>
                    </li>
                    <li id="menu-item-276" className="menu-item menu-item-type-custom menu-item-object-custom menu-item-276" >
                      <Link to="https://shabdtoday.com/">
                        <span>info@shabadtoday.org</span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
      </div>
    </div>
      </div >
    </div >
  );
}
